<script lang="ts">
  import { clickoutside } from '$lib/ui';

  export let title: string;
  export let classProps = '';
  export let buttonClassProps = '';
  export let override = false;

  export let show = false;
</script>

<div
  use:clickoutside={{}}
  on:clickoutside={() => {
    show = false;
  }}
  class="mr-2 flex flex-1
  "
>
  <button
    on:click={() => (show = !show)}
    class="flex
    flex-1
    flex-row rounded-md border
     border-gray-300
    px-1 py-1
    text-black
    shadow-sm transition
    focus:outline-none
    focus:ring
     disabled:opacity-25 {buttonClassProps
      ? buttonClassProps
      : 'bg-gray-100 ring-gray-200 hover:bg-gray-200 focus:border-gray-600 focus:ring-gray-300 active:bg-gray-300'}"
  >
    <span class="flex-1">{title}</span>
    <!-- Heroicon name: mini/chevron-up-down -->
    <svg
      class="h-3 w-3 justify-end self-center text-gray-400"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fill-rule="evenodd"
        d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
        clip-rule="evenodd"
      />
    </svg>
  </button>

  {#if show}
    <div
      class="{override
        ? ''
        : 'absolute left-0 z-40 mt-9 w-full rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none'} {classProps}"
    >
      <slot />
    </div>
  {/if}
</div>
